import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { rio } from '@amzn/rio-design-tokens';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
const aspectRatioByWidth = `
  // Retain aspect ratio by width
  width: 100%;
  height: auto;
`;
const aspectRatioByHeight = `
  // Retain aspect ratio by height
  width: auto;
  height: 100%;
  // Control max dimensions
  max-width: 100%;
  max-height: MIN(calc(100vh - 250px), 100vw);
`;
const StyledSwiper = styled(Swiper) `
  background-color: ${rio.semantic.color.background.primary};

  .swiper-wrapper {
    align-items: ${({ fullscreen }) => (fullscreen === 'true' ? 'start' : 'center')};
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    ${({ fullscreen }) => (fullscreen === 'true' ? aspectRatioByWidth : aspectRatioByHeight)}
  }
`;
const StyledPagination = styled.div `
  position: relative;
  text-align: center;

  --swiper-pagination-color: ${({ theme }) => theme.rio.semantic.color.imagePagination.selected};
  --swiper-pagination-bullet-inactive-color: ${({ theme }) => theme.rio.semantic.color.imagePagination.unselected};
  --swiper-pagination-bullet-inactive-opacity: 1;
`;
export const ImageSlider = ({ images = [], initialSlide = 0, showPagination = true, fullScreen = 'false', loop = true, }) => {
    const theme = useTheme();
    const swiperRef = React.useRef();
    // Reinit pagination on theme changes to fix CSS retention issues
    React.useEffect(() => {
        if (!swiperRef.current)
            return;
        swiperRef.current.pagination.init();
    }, [theme.mode]);
    return (_jsxs(_Fragment, { children: [_jsx(StyledSwiper, { modules: [Pagination], pagination: {
                    enabled: showPagination && images.length > 1,
                    el: '.swiper-pagination',
                    dynamicBullets: true,
                    dynamicMainBullets: 3,
                }, loop: images.length > 1 ? loop : false, initialSlide: initialSlide, fullscreen: fullScreen, onInit: (swiper) => {
                    swiperRef.current = swiper;
                }, onUpdate: (swiper) => {
                    // Reset the slide to 0 on variation changes
                    swiper.slideTo(0, 0);
                }, "data-testid": "image-swiper", children: images.map((image, index) => (_jsx(SwiperSlide, { "data-testid": "image-slide", children: _jsx("img", { src: image.highRes || image.lowRes, alt: image.altText, onError: (e) => {
                            // Fallback to lowRes if highRes fails
                            const target = e.target;
                            if (target.src !== image.lowRes) {
                                target.src = image.lowRes;
                            }
                        } }) }, `${image.altText} ${index}`))) }), _jsx(StyledPagination, { className: "swiper-pagination", "data-testid": "swiper-pagination" })] }));
};
